export const taskTableColumns = [
    { headName: "Pin", field: "is_pinned", sort: true, filter: false, width: "40px"},
    { headName: "Reference", field: "reference", sort: false, filter: true,width: "120px"},
    { headName: "Tags", field: "tags", sort: true, filter: true,width: "120px"},
    { headName: "Task", field: "task", sort: true, filter: true,required:true,width: "120px"},
    { headName: "Note", field: "note", sort: true, filter: false,width: "120px"},
    { headName: "Status", field: "status", sort: true, filter: true,required:true,width: "80px"},
    { headName: "Progress", field: "progress", sort: true, filter: true,width: "120px"},
    { headName: "Due", field: "due", sort: true, filter: true,width: "100px"},
    { headName: "Reminder(days)", field: "remind", sort: true, filter: false,width: "100px"},
    { headName: "Escalate(days)", field: "escalate", sort: true, filter: false,width: "100px"},
    { headName: "Created on", field: "created_on", sort: true, filter: true,width: "80px"},
    { headName: "Assigned to", field: "assigned_to", sort: true, filter: true,required:true,width: "100px"},
    { headName: "Owned By", field: "owned_by_user", sort: true, filter: false,required:true,width: "90px"},
    { headName: "Action", field: "action", isAction: true, width: "100px" }
];